
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import AddPartsGroup from '@/views/parts/components/addPartsGroup.vue'
import { delGroupView, groupViewList } from "@/api/group";

@Component({
  name: "PartsGroups",
  components: {
    AddPartsGroup
  },
})
export default class extends Vue {
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };
  private tableData:any = [];
  private dialogPartsGroupsVisible = false;
  private editorData:any={};

  created() {
    this.getGroupList()
  }
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getGroupList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getGroupList();
  }
  private getGroupList() {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      group_type: 20,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
    };
    groupViewList(params).then((res:any) => {
      if (res.data) {
        this.pagination.total = res.data.count
        this.tableData = res.data.list;
        for (let index = 0; index < this.tableData.length; index++) {
          if (this.tableData[index].department_list && this.tableData[index].department_list.length > 0) {
            this.tableData[index].department_list.forEach((element:any) => {
              this.tableData[index].departmentName = (this.tableData[index].departmentName ? this.tableData[index].departmentName : '') + element.name + ','
            });
          }
          if (this.tableData[index].part_list && this.tableData[index].part_list.length > 0) {
            this.tableData[index].part_list.forEach((element:any) => {
              this.tableData[index].partName = (this.tableData[index].partName ? this.tableData[index].partName : '') + element.name + ','
            });
          }
          this.tableData[index].departmentName = this.tableData[index].departmentName.substring(0, this.tableData[index].departmentName.length - 1)
          this.tableData[index].partName = this.tableData[index].partName.substring(0, this.tableData[index].partName.length - 1)
        }
      } else {
        this.pagination.total = 0
        this.tableData = []
      }
    }).catch(err => {
      let msg = err.msg;
      this.pagination.total = 0
      this.tableData = []
    })
  }
  private operationGroup(val:any) {
    this.editorData = val
    this.dialogPartsGroupsVisible = true;
  }
  private deleteGroup(val:any) {
    let _this = this
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let params:any = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          user_name: UserModule.getUserName,
          company_name: UserModule.getCompanyName,
          group_id: val.id,
        };
        delGroupView(params).then((res:any) => {
          _this.showSuccessMsg(res.msg)
          _this.getGroupList()
        }).catch(err => {
          _this.showErrorMsg(err.msg);
        })
      })
      .catch(() => {});
  }

  private groupsAdd() {
    this.editorData = {}
    this.dialogPartsGroupsVisible = true;
  }
  private close(val:boolean, isRef:boolean) {
    this.dialogPartsGroupsVisible = val;
    if (isRef) {
      this.getGroupList()
    }
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
